import { Check } from "lucide-react";
import React from "react";

import type * as ozon from "@/api/ozonSupply";
import { cn } from "@/lib/utils";
import { STEPS, nextStep, stepOf, type OzonStage } from "./ozonStage";

/** Где поставка и что делать дальше — одной полосой.
 *
 *  Поставка живёт неделями и проходит шесть шагов; набор кнопок над раскладкой об этом не говорил
 *  ничего — по нему нельзя было понять ни «сколько уже сделано», ни «что сейчас». Фраза «что
 *  дальше» стоит НАД шагами и объясняет главную кнопку под ними (а на «заявка отправлена» —
 *  почему кнопки нет).
 */
export function StageProgress({
  stage,
  d,
}: {
  stage: OzonStage;
  d: ozon.OzonDirection;
}): React.ReactElement {
  const at = stepOf(stage);
  return (
    <div className="space-y-1.5">
      <p className="text-sm">{nextStep(stage, d)}</p>
      <ol className="flex flex-wrap items-center gap-x-1 gap-y-1 text-xs">
        {STEPS.map((name, i) => (
          <li key={name} className="flex items-center gap-1">
            {i > 0 && (
              <span
                aria-hidden
                className={cn(
                  "mr-1 h-px w-4",
                  i <= at ? "bg-emerald-500" : "bg-border",
                )}
              />
            )}
            <span
              aria-current={i === at ? "step" : undefined}
              className={cn(
                "flex items-center gap-1 rounded-full px-2 py-0.5",
                i < at && "text-emerald-600 dark:text-emerald-400",
                i === at && "bg-foreground font-medium text-background",
                i > at && "text-muted-foreground/60",
              )}
            >
              {i < at && <Check className="size-3" />}
              {name}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}
